import { Pipe, PipeTransform, Inject, PLATFORM_ID } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';

@Pipe({
  name: 'cleanTableHtml',
  standalone: true,
})
export class CleanTableHtmlPipe implements PipeTransform {
  constructor(
    private sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  transform(value: string): SafeHtml {
    if (!isPlatformBrowser(this.platformId)) {
      // Safe: HTML is sanitized and managed by trusted CMS administrators.
      return this.sanitizer.bypassSecurityTrustHtml(value);
    } else {
      const parser = new DOMParser();
      const doc = parser.parseFromString(value, 'text/html');
      const elements = doc.querySelectorAll('table, table *');

      const ATTRS_TO_REMOVE = [
        'class',
        'width',
        'height',
        'border',
        'cellpadding',
        'cellspacing',
        'padding',
        'margin',
        'background',
        'align',
        'valign',
      ] as const;

      elements.forEach((el) => {
        const elNode = el as HTMLElement;

        ATTRS_TO_REMOVE.forEach((attr) => elNode.removeAttribute(attr));

        if (elNode.style.cssText) {
          elNode.style.cssText = elNode.style.cssText.replace(
            /\s*!important/gi,
            '',
          );
        }
      });

      // Safe: HTML is sanitized and managed by trusted CMS administrators.
      return this.sanitizer.bypassSecurityTrustHtml(doc.body.innerHTML);
    }
  }
}
